var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.201,
    height: 20,
    viewBox: "0 0 72.201 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18376",
    "data-name": "Group 18376",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19332",
    "data-name": "Path 19332",
    d: "M18.41,2.857A8,8,0,0,1,24.547,0h5.5V4h-5.5a4,4,0,0,0-3.07,1.428L11.634,17.141A7.994,7.994,0,0,1,5.5,20H0V16H5.5A4,4,0,0,0,8.564,14.57Z",
    fill: "#de3919"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17055",
    "data-name": "Rectangle 17055",
    width: 4.206,
    height: 20,
    transform: "translate(33.997 -0.001)",
    fill: "#de3919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19333",
    "data-name": "Path 19333",
    d: "M59.484,2.857l3.387,4.031,3.388-4.031A8,8,0,0,1,72.4,0h5.5V4H72.4a4,4,0,0,0-3.069,1.428L65.485,10l3.843,4.57A4,4,0,0,0,72.4,16h5.5v4H72.4a8,8,0,0,1-6.138-2.858L62.871,13.11l-3.387,4.031A8,8,0,0,1,53.347,20h-5.5V16h5.5a4,4,0,0,0,3.067-1.429L60.256,10,56.414,5.427A4,4,0,0,0,53.347,4h-5.5V0h5.5a8,8,0,0,1,6.137,2.858",
    transform: "translate(-5.691)",
    fill: "#de3919"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixLogo);
export default __webpack_public_path__ + "static/media/six-logo.ca1c488781701ef86fe34600abbc3bc7.svg";
export { ForwardRef as ReactComponent };